<template>
  <fn-page-container>
    <suspense>
      <fn-product-listing
        :corrected-search-term="route.query.correctedText"
        :product-listing-template="productListingTemplate"
        :breadcrumbs="breadcrumbs"
      />
    </suspense>
  </fn-page-container>
</template>

<script setup lang="ts">
// PageMeta `key` is necessary to trigger a full page reload when changing filters,
// by default it uses `route.path` which doesn't include filters from `route.query`
definePageMeta({
  name: 'search',
  key: (route) => route.fullPath,
  routeCmsPage: () => 'search',
});

const nuxtApp = useNuxtApp();
const mainStore = useMainStore();
const route = useRoute();

let page = await mainStore.loadRoutePage(route);
let breadcrumbs;

const productListingTemplate = await useProductListingTemplate(nuxtApp, page);

if (productListingTemplate?.navigateTo) {
  await navigateTo(productListingTemplate.navigateTo);
} else {
  // Sync changed page to local page and delete it from PLP template,
  // this should make it harder to accidentally mix up further adjustments
  if (productListingTemplate?.page) {
    page = productListingTemplate.page;
    delete productListingTemplate.page;
  }
  breadcrumbs = productListingTemplate?.breadcrumbs;

  const setSearchTerm = () => {
    mainStore.searchTerm = route.query.text;
  };
  const setRobots = () => {
    page.content.meta.robots = ['noindex', 'follow'];
  };

  setSearchTerm();
  setRobots();

  usePageMeta({ page });

  /**
   * Wait for DOM updates and emit custom nuxt 'scroll:content:loaded' hook
   * in order to properly handle scroll position on navigate back.
   */
  watchPostEffect(() => {
    nuxtApp.callHook('scroll:content:loaded');
  });
}
</script>
